import { useState, useContext } from "react";
import { Container, Group, Image, Button, Modal } from "@mantine/core";
import ExperienceContext from "./ExperienceContext";
import audioSpot from "../../static/svg/audio.svg";
import { CDN_URL } from "../../constant";
function AudioSpotControls({ activePanoId, selectedObject, closeControls }) {
	const { deleteAudioSpot } = useContext(ExperienceContext);
	const [isViewOpen, setIsViewOpen] = useState(false);
	return (
		<>
			<Group
				style={{
					height: "96px",
					width: "340px",
					backgroundColor: "#040f1fcc",
					padding: "10px 20px 10px 20px",
					borderRadius: "5px",
				}}
			>
				<Container
					px={0}
					mx={0}
					style={{
						backgroundColor: "#00000099",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						width: "50px",
						height: "50px",
						borderRadius: "50px",
					}}
				>
					<Image src={audioSpot} alt="Information" width={"25px"} />
				</Container>
				<Container px={0} mx={0} style={{ width: "230px" }}>
					<Group direction="column" spacing={10}>
						<Group
							direction="row"
							style={{
								justifyContent: "end",
								alignItems: "center",
								width: "100%",
							}}
						>
							<Button
								variant="outline"
								size="xs"
								radius={"sm"}
								py={5}
								style={{
									fontWeight: "normal",
									fontSize: "14px",
									color: "#ffffff",
									borderColor: "#4dabf7",
								}}
								onClick={() => {
									setIsViewOpen(true);
								}}
							>
								Listen
							</Button>
							<Button
								variant="outline"
								size="xs"
								radius={"sm"}
								py={5}
								style={{
									fontWeight: "normal",
									fontSize: "14px",
									color: "#ffffff",
									backgroundColor: "#e03131",
									borderColor: "#e03131",
								}}
								onClick={() => {
									deleteAudioSpot(
										activePanoId,
										selectedObject.id
									);
									closeControls();
								}}
							>
								Delete
							</Button>
						</Group>
					</Group>
				</Container>
			</Group>
			<Modal
				centered
				size="lg"
				opened={isViewOpen}
				onClose={() => setIsViewOpen(false)}
				title={selectedObject.text}
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
			>
				<audio controls>
					<source
						src={CDN_URL + selectedObject.url}
						type="audio/mpeg"
					/>
					Your browser does not support the audio element.
				</audio>
			</Modal>
		</>
	);
}

export default AudioSpotControls;
